import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  alarmResponseStaleMinutes,
  isLargeScreen,
  isLargeScreenFun,
  formatDateTimeStamp,
  dateRangeValueConverter,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../../../shared/services/orientationlock.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { JobsService } from '../../jobs/jobs.service';
import { ClientsService } from '../../clients/clients.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DatetimePickerComponent } from '../../../../shared/components/datetime-picker/datetime-picker.component';
import { formatDate } from '@angular/common';

@Component({
  selector: 'gtapp-scheduled-patrol-jobs',
  standalone: false,
  templateUrl: './scheduled-patrol-jobs.component.html',
  styleUrl: './scheduled-patrol-jobs.component.scss',
})
export class ScheduledPatrolJobsComponent implements OnInit, OnDestroy {
  // redirect components

  // manual pagination components
  previous: number = 0;
  pageSize: number = 5;
  totalRows: any;
  pageNum: number = 1;
  totalPages: number = 0;
  mobilePageSize = 5;
  // manual pagination components
  largeView: Boolean = isLargeScreen;
  statusData: any = [];
  userData: any;

  dropDownJobs: any;

  defaultJob: boolean = true;
  listJobData: any = [];

  isLargeScreenSubscription: Subscription = new Subscription();
  // showing data as card list instead of table
  jobCardsDetails: any = {
    // text styling can be updated here

    groupDetails: (row: any) => {
      if (
        row?.status == 'Closed' ||
        row?.status_identity == 2 ||
        row?.status_identity == 3
      ) {
        return {
          opacity: '0.5',
        };
      } else {
        for (let i = 0; i < this.statusData.length; i++) {
          if (this.statusData[i].name === row?.status) {
            return {
              border: `1px solid ${this.statusData[i].additional_info?.style?.snubbed['border-color']}`,
            };
          }
        }
      }

      return {};
    },
  };

  globalFilter: any;

  totalJobCount: any;

  tableStyle = {
    'overflow': 'auto',
    'max-height': '100%',
  };
  otherParams: any = {
    saveFilters: true,
    normalCard: true,
    tableRowStyle: (rowData: any) => {
      if (
        rowData?.status &&
        (rowData?.status == 'Closed' ||
          rowData?.status_identity == 2 ||
          rowData?.status_identity == 3)
      ) {
        return {
          opacity: '0.5',
        };
      }
      return {};
    },
  };

  jobDetailsTableView: any = [];

  sortKeys: any = [];

  searchBody: any;
  loading = false;

  infiniteJobList: any = [];
  infiniteJobListJobCount: number = 0;

  isDispatchUser: boolean = false;
  isAdmin: boolean = false;

  lastApiResponseHadData: boolean = true;
  lastSearchStr: any;

  apiCallMade: boolean = false;
  jobFilters: boolean = false;
  isSortPopupVisisble: boolean = false;

  sortItemList: any = [];

  webSocketSubscription: any;

  filterJobType: string = '';
  reviewJobDefaultFiter: boolean = false;
  routerSubscription!: Subscription;

  siteClientLookupData: any = {
    client: {
      name: 'Client',
      value: '',

      data: null,
    },
    site: { name: 'Site', value: '', data: null },
  };
  siteListData: any = [];
  clientDropDownList: any = [];
  initialDataList: any = {};
  dateRange: any;
  dateRangeValue: any;
  searchPressed = false;
  constructor(
    private jobService: JobsService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private cdr: ChangeDetectorRef,
    private orientationService: OrientationLockService,
    private webSocketService: WebSocketService,
    private clientService: ClientsService,
    private dialogService: ModalDialogueService,
  ) {}
  threshold = 100;
  hideLoaderOnScroll: boolean = false;

  async ngOnInit(): Promise<void> {
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        // if (event?.event === 'wsn_response_job_update') {
        //   this.findDeviceData();
        // }
      });

    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
          this.resetFilters();
        }
      });

    this.userData = this.appService.getUserData();
    this.isDispatchUser = this.dataCheckService.isDispatchUser();
    this.isAdmin = this.dataCheckService.isUserAdmin();

    this.pageSize = Number(this.userData?.preferences?.job_page_size || 5);

    this.getJobStatuses();
    this.searchClients('');
    this.onSiteSearch('');
    const spSearchFilters = JSON.parse(
      sessionStorage.getItem(btoa('spSearchFilters')) || '{}',
    );

    if (Object.values(spSearchFilters)?.length) {
      this.dateRange = spSearchFilters?.dateRange;
      this.siteClientLookupData = spSearchFilters?.siteClientLookupData;
      this.searchBody = spSearchFilters?.searchBody;
      this.searchData();
    } else {
      const yesterDay = new Date();
      yesterDay.setDate(new Date().getDate() - 1);
      this.dateRange = {
        start: yesterDay.setHours(0, 0, 0, 0),
        end: new Date().setHours(0, 0, 0, 0),
      };
    }
    this.dateRangeValue = `${dateRangeValueConverter(
      this.dateRange?.start,
      true,
    )} - \n ${dateRangeValueConverter(this.dateRange?.end, true)}`;
  }

  ngOnDestroy(): void {
    this.isLargeScreenSubscription?.unsubscribe();
    if (this.webSocketSubscription) {
      this.webSocketSubscription?.unsubscribe();
    }
    this.routerSubscription?.unsubscribe();
    window.onpopstate = null;
  }

  getNestedAssignees(rowData: any, maxNumber: any = 2) {
    if (rowData?.assignee?.length > maxNumber) {
      return `${rowData?.assignee?.slice(0, maxNumber)} ...`;
    } else {
      return rowData?.assignee;
    }
  }

  getJobStatuses() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        const scheduledPatrolType = response?.data?.find(
          (item: any) => item?.type_identity == 6,
        );
        const statuses = scheduledPatrolType?.statuses?.map(
          (status: any) => status?.status,
        );
        if (statuses?.length) {
          this.statusData = statuses || [];

          this.statusData.push({
            id: '0',
            name: 'Closed',
            additional_info: {
              style: {
                snubbed: {
                  'color': 'var(--color-basic-1100)',
                  'background-color': 'var(--color-basic-100)',
                },
              },
            },
          });
        }
      }
    });
  }

  openIndividualJob(job: any) {
    sessionStorage.setItem(
      this.largeView ? 'largeView' : 'mobileView',
      JSON.stringify(this.jobFilters),
    );
    this.spinnerService.show();

    if (job?.status_identity === 9) {
      this.router.navigate([`/job-review/${job.job_key}`], {
        queryParams: { jId: job?.id },
      });
    } else {
      this.router.navigate([`/job-detail/${job.job_key}`], {
        queryParams: { jId: job?.id },
      });
    }
  }

  onFilterSearch() {
    let body = {
      rows: 5,
      search_str: this.globalFilter,
      ...this.getJobTypeFilter(),
    };
    if (this.lastSearchStr) {
      !this.globalFilter.includes(this.lastSearchStr)
        ? (this.apiCallMade = true)
        : (this.apiCallMade = false);
    } else {
      this.apiCallMade = true;
    }
    if (this.apiCallMade || this.lastApiResponseHadData) {
      this.jobService.fetchJobDetails(body, {}).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.dropDownJobs = [...response?.data?.values];
          this.lastApiResponseHadData = this.dropDownJobs.length > 0;
          this.lastSearchStr = this.globalFilter;
        }
      });
    }
  }
  onFilterApply(event: any) {
    if (event?.target?.value && event?.target?.value?.length >= 3) {
      this.globalFilter = event?.target?.value;

      this.onFilterSearch();
    }
    if (
      event === true &&
      this.globalFilter != '' &&
      this.globalFilter != null
    ) {
      this.pageNum = 1;
      this.previous = 0;

      this.findDeviceData();
    } else if (
      event.key === 'Enter' &&
      this.globalFilter != '' &&
      this.globalFilter != null
    ) {
      this.pageNum = 1;
      this.previous = 0;

      this.findDeviceData();
    }
  }

  onClickPagination(event: any) {
    this.previous = event.previous;
    this.pageNum = event.pageNum;
    this.pageSize = event.pageSize;

    this.findDeviceData();
  }
  onChangePagination(event: any) {
    this.previous = event?.paginationData?.previousRows;
    this.pageNum = event?.paginationData?.pageNum;
    this.pageSize = event?.paginationData?.rows;
    this.otherParams.paginationData = {
      ...event?.paginationData,
    };
    this.findDeviceData();
  }
  sortColumn(body: any) {
    this.sortKeys = body?.sortList || [];
    this.findDeviceData();
  }
  sortField(column: any) {
    this.isSortPopupVisisble = false;
    column['sortOrder'] =
      column?.sortOrder === 'asc'
        ? 'desc'
        : column?.sortOrder === 'desc'
          ? null
          : 'asc';

    this.jobDetailsTableView.forEach((item: any) => {
      if (item?.name !== column?.name) {
        item.sortOrder = null;
      }
      this.cdr.detectChanges();
    });

    let sortKeyValue: any = column?.sortKey
      ? typeof column?.sortKey === 'string'
        ? column?.sortKey
        : column?.name
      : column?.name;
    let sortKey: any =
      column?.sortOrder == 'desc'
        ? `-${sortKeyValue}`
        : column?.sortOrder == 'asc'
          ? sortKeyValue
          : '';

    this.sortKeys = [];
    if (sortKey) this.sortKeys = [sortKey];

    this.totalRows = null;
    this.previous = 0;
    this.pageNum = 1;

    this.findDeviceData();
  }

  searchColumn(event: any) {
    this.searchBody = event?.searchParams || {};
    this.getLargeDevicesJobs();
  }
  async findDeviceData() {
    // function to dynamically find screen width and determine whther data is to be processed for mobile or large devices
    this.getTotalJobCountOnFilter();
    if (this.largeView) {
      this.getLargeDevicesJobs();
    } else {
      this.pageSize = this.mobilePageSize;
      // mobile devices
      this.infiniteJobList = [];
      this.infiniteJobListJobCount = 0;

      this.getInfinteLoadData();
    }
  }
  getJobTypeFilter() {
    let body: any = { runsheet: 1 };
    if (this.defaultJob) {
      body.default_jobs = 1;
    }
    if (this.sortKeys) body.sort_key = this.sortKeys;
    if (this.globalFilter) {
      body.search_str = this.globalFilter;
    }
    if (this.dateRange) {
      this.searchBody = this.searchBody || {};

      this.searchBody.event_date__lte = formatDate(
        new Date(this.dateRange?.end),
        'yyyy-MM-dd',
        'en_US',
      );
      this.searchBody.event_date__gte = formatDate(
        new Date(this.dateRange?.start),
        'yyyy-MM-dd',
        'en_US',
      );
    }
    if (this.siteClientLookupData?.client?.data?.id) {
      body.company_id = this.siteClientLookupData?.client?.data?.id;
    }
    if (this.siteClientLookupData?.site?.data?.id) {
      body.site_id = this.siteClientLookupData?.site?.data?.id;
    }

    if (this.searchBody) body.search_filter = this.searchBody;
    sessionStorage.setItem(
      btoa('spSearchFilters'),
      JSON.stringify({
        dateRange: this.dateRange,
        siteClientLookupData: this.siteClientLookupData,
        searchBody: this.searchBody,
      }),
    );

    return body;
  }
  getTotalJobCountOnFilter() {
    let body = this.getJobTypeFilter();
    body.rows = 1;
    body.default_jobs = 0;
    this.jobService.fetchJobDetails(body, 0).subscribe((response: any) => {
      this.totalJobCount = response?.data?.total_size;
    });
  }
  getInfinteLoadData() {
    if (this.loading) {
      return;
    }

    if (this.largeView) {
      return;
    }

    let param: any = {};
    let body = this.getJobTypeFilter();

    body.rows = this.mobilePageSize;

    this.loading = true;

    if (this.previous) {
      body['previous'] = this.previous;
    }
    if (!this.hideLoaderOnScroll) {
      this.spinnerService.show();
    }
    this.jobService.fetchJobDetails(body, param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.totalRows = response?.data?.total_size;

        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        let newList = response?.data?.values;
        this.infiniteJobList = this.infiniteJobList.concat(newList);

        this.previous = this.previous + this.mobilePageSize;
        this.infiniteJobListJobCount =
          this.infiniteJobListJobCount + newList?.length;

        this.loading = false;
      }
      this.spinnerService.hide();
    });
  }

  getLargeDevicesJobs() {
    let param: any = { large_devices: 1 };
    let body = this.getJobTypeFilter();

    if (this.pageSize) {
      body['rows'] = this.pageSize;
      let userData = this.appService.getUserData();
      if (userData?.preferences) {
        userData.preferences.job_page_size = this.pageSize;
        this.appService.setUserData(userData);
      }
    }
    if (this.previous) {
      body['previous'] = this.previous;
    }

    this.spinnerService.show();

    this.jobService.fetchJobDetails(body, param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.listJobData = response?.data?.values;

        this.totalRows = response?.data?.total_size;
        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: this.totalPages,
        };
      }
      this.spinnerService.hide();
    });
  }
  resetFilters() {
    this.globalFilter = null;
    this.previous = 0;
    this.pageNum = 1;

    this.totalRows = null;

    this.otherParams.paginationData = {
      totalRows: this.totalRows,
      previousRows: this.previous,
      rows: this.pageSize,
      pageNum: this.pageNum,
      totalPages: this.totalPages,
    };
    this.findDeviceData();
  }

  showAllJobsDesktop() {
    this.defaultJob = !this.defaultJob;
    this.resetFilters();
  }

  loadMoreJobs() {
    this.hideLoaderOnScroll = true;
    this.getInfinteLoadData();
  }
  isActiveResponseJob(jobData: any) {
    return !(
      jobData?.status == 'Closed' ||
      jobData?.status_identity == 2 ||
      jobData?.status_identity == 3 ||
      jobData?.roster_scheduler
    );
  }
  getJobStatusStyle(jobData: any, isLargeView = false) {
    let customStyle: any = {};
    let additionalStyle: any = {};

    if (isLargeView) {
      this.statusData?.forEach((element: any) => {
        if (element.name === jobData?.status) {
          customStyle = {
            'color': `${element.additional_info?.style?.snubbed?.color}`,
            'background-color': `${element.additional_info?.style?.snubbed['background-color']}`,
            'text-align': 'center',
            'white-space': 'pre-line',
            ...additionalStyle,
          };
        }
      });
    } else {
      this.statusData?.forEach((element: any) => {
        if (element.name === jobData?.status) {
          customStyle = {
            'color': `${element.additional_info?.style?.snubbed?.color}`,
            'background-color': `${element.additional_info?.style?.snubbed['background-color']}`,
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'float': 'right',
            'font-size': 'small',
            'text-align': 'center',
            'white-space': 'pre-line',
            ...additionalStyle,
          };
        }
      });
    }

    return customStyle;
  }

  getJobDetailView() {
    const deskTopTableItems = [
      {
        header: 'Start',
        name: 'event_date',
        datetimeObj: true,
        dateTimeFormat: 'd MMM y',
        sortKey: 'event_date',
      },
      {
        header: 'Docket No.',
        searchKey: 'job_key',
        tableColumnStyle: {
          'white-space': 'pre-line',
          'font-size': '0.8rem',
        },
        nestedValue: (row: any) => {
          let appendList = [row?.job_key];
          if (row?.ext_job_id) appendList.push(`[${row?.ext_job_id}]`);

          return appendList.join('\n');
        },
      },
      {
        header: 'Name',
        name: 'run_sheet_name',
        searchKey: 'run_sheet_name',
      },
      {
        header: 'Client',
        name: 'company',
        sortKey: 'company__company_name',
        hideItem:
          this.siteClientLookupData?.client?.data?.id ||
          this.siteClientLookupData?.site?.data?.id,
      },

      {
        header: 'Site',
        name: 'site_name',
        sortKey: 'site_name',
        hideItem: this.siteClientLookupData?.site?.data?.id,
      },

      {
        header: 'Address',
        name: 'sites',
        searchKey: 'sites',
      },
      {
        header: 'Guard',
        name: 'assignee',
        nestedValue: (row: any) => {
          return this.getNestedAssignees(row);
        },

        searchKey: 'assignee',
      },
      {
        header: 'Status',
        nestedValue: (row: any) => {
          return row?.status || 'Not Started';
        },
        dropDownList: () => {
          return this.statusData;
        },

        conditionalColumnStyle: (row: any) => {
          return this.getJobStatusStyle(row, true);
        },
        dropdownKey: 'status_id',
      },
    ]?.filter((item: any) => !item?.hideItem);

    if (!this.sortItemList?.length)
      this.sortItemList = deskTopTableItems?.filter(
        (item: any) => item?.sortKey,
      );
    if (this.largeView) {
      return deskTopTableItems;
    } else {
      let cardDetailList: any = [
        {
          nestedValue: (row: any) => {
            let appendList = [];
            if (row?.status) appendList.push(row?.status);

            return appendList.join('\n');
          },
          conditionalRowStyle: (row: any) => {
            return this.getJobStatusStyle(row, false);
          },
        },

        {
          nestedValue: (row: any) => {
            if ([1, 2, 3, 9, 10, 11, 12, 13].includes(row?.status_identity))
              return null; // if job status is complete,closed, cancelled, no need to worry about this

            return (
              'UPDATED: ' +
              String(
                formatDateTimeStamp(
                  row?.modified_date,
                  'd MMM y HH:mm',
                  'en_US',
                ),
              )
            );
          },
          conditionalRowStyle: (row: any) => {
            if ([1, 2, 3, 9, 10, 11, 12, 13].includes(row?.status_identity))
              return {}; // if job status is complete,closed, cancelled, no need to worry about this

            return {
              'border': '1px solid #333',
              'border-radius': '3px',
              'font-size': 'small',
              'padding-left': '0.5rem',
              'padding-right': '0.5rem',
            };
          },
        },

        {
          name: 'site_name',
          cardRowStyle: { 'font-weight': 'bold' },
          suffixStyle: { 'font-weight': 'normal' },
          suffixNestedValue: (row: any) => {
            return ` [${row?.company}]`;
          },
        },
        // Address
        {
          name: 'sites',
          cardRowStyle: { 'font-size': 'small' },
        },

        {
          nestedValue: (row: any) => {
            if (row?.ext_job_id) {
              return `${row?.job_key} [${row?.ext_job_id}]`;
            } else {
              return row?.job_key;
            }
          },
          cardRowStyle: {
            'font-size': 'small',
          },
        },
      ];

      if (this.isAdmin || this.isDispatchUser) {
        cardDetailList.push({
          nestedValue: (row: any) => {
            const isAssigneeEmpty =
              !row?.assignee ||
              row?.assignee.every((item: any) => item.trim() === '');
            if (isAssigneeEmpty) {
              return 'No Guard Assigned';
            } else if (row?.assignee) {
              return row.assignee.join(', '); // Join names with a comma and space
            }
          },
          conditionalRowStyle: (row: any) => {
            const isAssigneeEmpty =
              !row?.assignee ||
              row?.assignee.every((item: any) => item.trim() === '');
            if (isAssigneeEmpty) {
              return {
                'color': 'var(--bs-red)',
                'width': 'fit-content',
                'font-size': '1rem',
                'font-weight': '700',
                'padding-top': '0.1rem',
              };
            }
            return { 'margin-top': '0.5rem' };
          },
        });
      }
      return cardDetailList;
    }
  }

  showAllDefaultReviewJobs() {
    this.previous = 0;
    this.pageNum = 1;
    this.reviewJobDefaultFiter = !this.reviewJobDefaultFiter;
    this.spinnerService.show();
    this.findDeviceData();
  }
  onClientSearch(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.clientDropDownList?.length)
    ) {
      this.searchClients(event.target.value);
    }
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.initialDataList.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onClientSelect(data: any) {
    this.resetVariables();
    this.siteClientLookupData = {
      client: {
        name: 'Client',
        value: data?.company_name,

        data: data,
      },
      site: { name: 'Site', value: '', data: null },
    };
    this.sortKeys = [];
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  onSelectSite(data: any) {
    this.resetVariables();
    this.siteClientLookupData = {
      client: {
        name: 'Client',
        value: '',

        data: null,
      },
      site: {
        name: 'Site',
        value: data?.company_name,

        data: data,
      },
    };
    this.sortKeys = [];
  }
  resetVariables() {
    this.siteClientLookupData = {
      client: {
        name: 'Client',
        value: '',
        data: null,
      },
      site: {
        name: 'Site',
        value: '',
        data: null,
      },
    };
    this.tableStyle = {
      'overflow': 'auto',
      'max-height': '100%',
    };
  }
  inputFocused(field: string) {
    this.siteClientLookupData.client = {
      name: 'Client',
      value: '',
      data: null,
    };
    this.siteClientLookupData.site = {
      name: 'Site',
      value: '',
      data: null,
    };
    if (field === 'site') {
      this.siteClientLookupData.client = {
        name: 'Client',
        value: '',
        data: null,
        hide: true,
      };
      setTimeout(() => {
        this.siteClientLookupData.client = {
          name: 'Client',
          value: '',
          data: null,
          disabled: true,
        };
      }, 10);
    }
    if (field === 'client') {
      this.siteClientLookupData.site = {
        name: 'Site',
        value: '',
        data: null,
        hide: true,
      };
      setTimeout(() => {
        this.siteClientLookupData.site = {
          name: 'Site',
          value: '',
          data: null,
          disabled: true,
        };
      }, 10);
    }
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    this.siteListData = [];
    this.clientDropDownList = [];
    setTimeout(() => {
      if (field === 'site') {
        this.siteListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }

      this.cdr.detectChanges();
    }, 200);
  }
  editField(field: string) {
    this.siteClientLookupData.site = {
      name: 'Site',
      value: '',
      data: null,
    };
    this.siteClientLookupData.client = {
      name: 'Client',
      value: '',
      data: null,
    };
    if (field == 'site') {
      this.shiftFocus('siteId');
    }
    if (field == 'client') {
      this.shiftFocus('clientLookupId');
    }

    this.updateInitialDataList(field);
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  openRangePicker() {
    const dialogeRef = this.dialogService.open(DatetimePickerComponent, {
      data: {
        dateRange: this.dateRange,
        showDateOnly: true,
        showFrom: 'tablePage',
      },
    });
    dialogeRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.dateRange = value;

        this.dateRangeValue = `${dateRangeValueConverter(
          this.dateRange?.start,
          true,
        )} - \n ${dateRangeValueConverter(this.dateRange?.end, true)}`;
      }
    });
  }
  searchData() {
    this.findDeviceData();
    this.searchPressed = true;
    this.jobCardsDetails.individualDetails = this.getJobDetailView();
    this.jobDetailsTableView = this.getJobDetailView();
  }
}
